<div class="AmBagsFooterResume ">
  <span class="AmBagsFooterResume-totalBags fs-22px">
    {{ totalBags }}
  </span>
  <span class="AmBagsFooterResume-text fs-20px" *ngIf="totalBags == 1">
    {{ 'PAGADO' }}
  </span>
  <span class="AmBagsFooterResume-text fs-20px" *ngIf="totalBags > 1">
    {{ 'PAGADOS' }}
  </span>
</div>
